import { resolveLocale } from '../i18n/locale';
import type { PartnerReward, PartnerRewardLocal } from './block-view';
import { PARTNER_PROGRAM_EN } from './i18n.en';
import { PARTNER_PROGRAM_RU, type PartnerProgramViewBundle } from './i18n.ru';

const COPY: Record<'ru' | 'en', PartnerProgramViewBundle> = {
  ru: PARTNER_PROGRAM_RU,
  en: PARTNER_PROGRAM_EN,
};

export function partnerProgramCopy(locale: string): PartnerProgramViewBundle {
  return COPY[resolveLocale(locale)];
}

/** «$3.00» — доллары всегда с центами и `$`, независимо от локали. */
export function formatUsdCents(cents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(cents / 100);
}

/**
 * Награда партнёра в валюте цены билета: price × percent / 100, округление до целых.
 * null — нет цены, цена 0, валюта USD (дубль долларовой части) или сумма округлилась в 0.
 */
export function partnerRewardLocal(
  price: number | null,
  percent: number,
  currency: string,
): PartnerRewardLocal | null {
  if (price == null || price === 0 || currency === 'USD') return null;
  const amount = Math.round((price * percent) / 100);
  if (amount === 0) return null;
  return { amount, currency, approx: (price * percent) % 100 !== 0 };
}

/** «≈ 5 GEL · $1.94 · 20 ⚡» (местная часть — только если есть). */
export function formatPartnerReward(reward: PartnerReward, locale: string): string {
  const parts: string[] = [];
  if (reward.local) {
    const { amount, currency, approx } = reward.local;
    const money = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(amount);
    parts.push(approx ? `≈ ${money}` : money);
  }
  parts.push(formatUsdCents(reward.usdCents), `${reward.energy} ⚡`);
  return parts.join(' · ');
}
